<template lang="pug">
  div
    .form__title
      slot(name='title')
    form.form__body(action='javascript://' v-if='params')
      .form__field
        label.form__label
          | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
        .form__field-body
          cs-multiselect(
            :show-labels="false"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            v-model="params.themes"
            :options="themes"
            track-by="value"
            placeholder=""
            :custom-label="themeLabel"
            :multiple="true"
          )
      .form__field
          label.form__label
              | {{ $i18n.t('trainer.trainer_gameFormSetting_isChooseByAlphabetSettingEnabled') }}
          .form__field-body
              cs-checkbox(
                  v-model='params.isChosenLettersSettingEnabled'
              )
      .form__field(v-if="params.isChosenLettersSettingEnabled" )
          label.form__label
              | {{ $i18n.t('trainer.trainer_gameFormSetting_chooseByAlphabet') }}
          .form__field-body
              cs-multiselect(
                  :show-labels="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :hide-selected="true"
                  v-model="params.chosenLetters"
                  :options="letters"
                  placeholder=""
                  :multiple="true"
              )
      .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
        label.form__label
          | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
        .form__field-body
          cs-spin-input(
            :value="params.amountOfPairs",
            :max="maxAvailableAmountOfPairs",
            :min="3",
            @increase="increaseAmountOfPairs",
            @decrease="decreaseAmountOfPairs",
            @input="params.amountOfPairs = $event",
          )
      .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
        label.form__label
          | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
        .form__field-body
          cs-spin-input(
            :value="params.numOfExamples",
            :max="numOfExamples",
            :min="3",
            @increase="increaseNumOfExamples",
            @decrease="decreaseNumOfExamples",
            @input="params.numOfExamples = $event",
          )
      .form__field.checkbox(v-if="gameMode !== 'course'")
        label.form__label.checkbox__label
          | {{ $i18n.t('trainer.trainer_gamePlayBox_tip') }}
        .form__field-body
          cs-checkbox(
            v-model="params.isHintEnabled",
            :checked='params && params.isHintEnabled',
          )
      divider
      slot(name='parameters')
      slot(name='help')
      .form__buttons(v-if='!usersIds')
        cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
          | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
        template(v-if="gameMode === 'free-game'")
          cs-button.form__button(color="blue", @click='saveGameMode' :disabled="!params.themes.length || blockSaveBtnIfChosenLettersAreNotSelected")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
        template(v-else='')
          cs-button.form__button(color="blue", @click='saveGame' :disabled="!params.themes.length || blockSaveBtnIfChosenLettersAreNotSelected")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
      .form__buttons(v-else='')
        cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
          | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
        cs-button.form__button(color="blue", @click='saveGame' :disabled="!params.themes.length || blockSaveBtnIfChosenLettersAreNotSelected")
          | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    const AVAILABLE_AMOUNT_OF_PAIRS = {
        sevenEightYears: 51,
        eightNineYears: 93,
        nineTenYears: 71,
        tenElevenYears: 46,
    };

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                viewTypesLeft: [
                    {
                        name: this.$i18n.t('couples.couples_view_images'),
                        type: 'image',
                    },
                ],
                themes: [
                    {
                        value: 'sevenEightYears',
                    },
                    {
                        value: 'eightNineYears',
                    },
                    {
                        value: 'nineTenYears',
                    },
                    {
                        value: 'tenElevenYears',
                    },
                ],
                letters: [
                    'А',
                    'Б',
                    'В',
                    'Г',
                    'Д',
                    'Е',
                    'Ё',
                    'Ж',
                    'З',
                    'И',
                    'Й',
                    'К',
                    'Л',
                    'М',
                    'Н',
                    'О',
                    'П',
                    'Р',
                    'С',
                    'Т',
                    'У',
                    'Ф',
                    'Х',
                    'Ц',
                    'Ч',
                    'Ш',
                    'Щ',
                    'Э',
                    'Ю',
                    'Я',
                ],
                amountOfPairs: 100,
                numOfExamples: 100,
                params: null,
            };
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        updated() {
            this.leftColumnView = _.find(this.viewTypesLeft, { type: this.params.leftColumn });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            maxAvailableAmountOfPairs() {
                return Object.entries(AVAILABLE_AMOUNT_OF_PAIRS).reduce((resultX, [key, value]) => {
                    if (this.params.themes.some(theme => theme.value === key)) {
                        resultX += value;
                    }
                    return resultX;
                }, 0);
            },
            blockSaveBtnIfChosenLettersAreNotSelected() {
                return this.params.isChosenLettersSettingEnabled && !this.params.chosenLetters.length;
            },
        },
        watch: {
            'params.isChosenLettersSettingEnabled': {
                handler(val) {
                    if (!val) {
                        this.params.chosenLetters = [];
                    }
                },
            },
            'params.themes': {
                handler(val, newVal) {
                    if (
                        val?.length &&
                        (val.length < newVal?.length || val.length === 1) &&
                        this.params.amountOfPairs > this.maxAvailableAmountOfPairs
                    ) {
                        this.params.amountOfPairs = this.maxAvailableAmountOfPairs;
                    }
                },
            },
        },
        methods: {
            themeLabel(theme) {
                return this.$i18n.t('trainer.trainer_gameFormSetting_' + `${theme.value}`);
            },
            decreaseAmountOfPairs() {
                if (this.params.amountOfPairs !== 2) {
                    this.params.amountOfPairs -= 1;
                }
            },
            increaseAmountOfPairs() {
                if (this.params.amountOfPairs <= this.maxAvailableAmountOfPairs) {
                    this.params.amountOfPairs += 1;
                }
            },
            decreaseNumOfExamples() {
                if (this.params.numOfExamples !== 1) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseNumOfExamples() {
                if (this.params.numOfExamples !== this.numOfExamples) {
                    this.params.numOfExamples += 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
